import { setCookie, getCookie } from '../base/_utilities';

const modal = document.getElementById('tfp_modal');


/**
 *
 *
 *
 */
const init = function() {

	if ( modal !== null ) {
		setupModals();
	}

};


/**
 *
 *
 *
 */
const setupModals = function() {

	const cookieExpiration = ( modal.getAttribute( 'data-tfp-modal-cookie-expire' ) ) ? modal.getAttribute( 'data-tfp-modal-cookie-expire' ) : 0;
	const cookieID 				 = ( modal.getAttribute( 'data-tfp-modal-cookie-id' ) ) ? modal.getAttribute( 'data-tfp-modal-cookie-id' ) : '';
	const cookieName  		 = 'tfp_modal_'+cookieID+'_viewed'
	const modalViewed 		 = getCookie( cookieName );

	const options = {
		src: '#tfp_modal',
		type: 'inline',
		animationDuration: 800,
		afterShow : () => {
			setCookie( cookieName, true, cookieExpiration );
		}
	};

	if ( modal !== null ) {

		if ( !modalViewed ) {
			setTimeout( () => {
				jQuery.fancybox.open(options);
			}, 2000 );
		}

	}

}

const api = {
	init: init
};

export default api;